import { Route } from '@angular/router';
import {
  superadminAuthCanActivateChild,
  superadminAuthCanMatch,
  superadminGuestCanActivate,
  superadminGuestCanMatch,
	superadminPermissionCanActivate,
	superadminPermissionCanMatch,
} from './auth/auth.guard';
import { createTenantUnsavedChangesGuard } from './features/tenant/create-tenant-page/create-tenant-unsaved-changes.guard';

export const appRoutes: Route[] = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'login'
	},
	{
		path: 'login',
		canMatch: [superadminGuestCanMatch],
		canActivate: [superadminGuestCanActivate],
		loadComponent: () =>
			import('./features/login/login-page.component').then((m) => m.SuperadminLoginPageComponent)
	},
	{
		path: 'verify-2fa',
		canMatch: [superadminGuestCanMatch],
		canActivate: [superadminGuestCanActivate],
		loadComponent: () =>
			import('./features/login/verification/verification').then((m) => m.Verification)
	},
	{
		path: 'forget-password',
		canMatch: [superadminGuestCanMatch],
		canActivate: [superadminGuestCanActivate],
		loadComponent: () =>
			import('./features/login/forget-password/forget-password').then((m) => m.ForgetPassword)
	},
	{
		path: 'reset-password',
		canMatch: [superadminGuestCanMatch],
		canActivate: [superadminGuestCanActivate],
		loadComponent: () =>
			import('./features/login/reset-password/reset-password').then((m) => m.ResetPassword)
	},
	{
		canMatch: [superadminAuthCanMatch],
		canActivateChild: [superadminAuthCanActivateChild],
		path: '',
		loadComponent: () =>
			import('./layout/superadmin-shell.component').then((m) => m.SuperadminShellComponent),
		children: [
			{
				path: 'dashboard',
				canMatch: [superadminPermissionCanMatch],
				canActivate: [superadminPermissionCanActivate],
				data: { permission: 'Dashboard.Read' },
				loadChildren: () =>
					import('./features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes)
			},
			{
				path: 'tenant',
				canMatch: [superadminPermissionCanMatch],
				canActivate: [superadminPermissionCanActivate],
				data: { breadcrumb: 'Tenant Management', permission: 'TenantManagement.Read' },
				loadComponent: () =>
					import('./features/tenant/tenant-page.component').then((m) => m.SuperadminTenantPageComponent)
			},
			{
				path: 'tenant/create',
				canMatch: [superadminPermissionCanMatch],
				canActivate: [superadminPermissionCanActivate],
				canDeactivate: [createTenantUnsavedChangesGuard],
				data: {
					parentBreadcrumb: 'Tenant Management',
					parentBreadcrumbLink: '/tenant',
					breadcrumb: 'Create Tenant',
					permission: 'TenantManagement.Read'
				},
				loadComponent: () =>
					import('./features/tenant/create-tenant-page/create-tenant-page.component').then((m) => m.CreateTenantPageComponent)
			},
			{
				path: 'tenant/manual-edit',
				canMatch: [superadminPermissionCanMatch],
				canActivate: [superadminPermissionCanActivate],
				canDeactivate: [createTenantUnsavedChangesGuard],
				data: {
					parentBreadcrumb: 'Tenant Management',
					parentBreadcrumbLink: '/tenant',
					breadcrumb: 'Edit Tenant',
					permission: 'TenantManagement.Read'
				},
				loadComponent: () =>
					import('./features/tenant/create-tenant-page/create-tenant-page.component').then((m) => m.CreateTenantPageComponent)
			},
			{
				path: 'tenant/edit',
				redirectTo: 'tenant/edit-approval',
				pathMatch: 'full'
			},
			{
				path: 'tenant/edit-approval',
				data: {
					parentBreadcrumb: 'Tenant Management',
					parentBreadcrumbLink: '/tenant',
					breadcrumb: 'Edit Tenant'
				},
				loadComponent: () =>
					import('./features/tenant/edit-tenant-page/edit-tennat').then((m) => m.EditTennat)
			},
			{
				path: 'tenant/view',
				canMatch: [superadminPermissionCanMatch],
				canActivate: [superadminPermissionCanActivate],
				data: {
					parentBreadcrumb: 'Tenant Management',
					parentBreadcrumbLink: '/tenant',
					breadcrumb: 'Tenant Details',
					permission: 'TenantManagement.Read'
				},
				loadComponent: () =>
					import('./features/tenant/tenant-details-page/tenant-details-page.component').then((m) => m.TenantDetailsPageComponent)
			},
			{
				path: 'tenant/application-view/:id',
				canMatch: [superadminPermissionCanMatch],
				canActivate: [superadminPermissionCanActivate],
				data: {
					parentBreadcrumb: 'Tenant Management',
					parentBreadcrumbLink: '/tenant',
					breadcrumb: 'Application View',
					permission: 'TenantManagement.Read'
				},
				loadComponent: () =>
					import('./features/tenant/application-view/application-view.component').then((m) => m.ApplicationViewComponent)
			},
			{
				path: 'user-management',
				canMatch: [superadminPermissionCanMatch],
				canActivate: [superadminPermissionCanActivate],
				data: { breadcrumb: 'User Management', permission: 'UserManagement.Read' },
				loadChildren: () =>
					import('./features/user-management/user-management.routes').then((m) => m.userManagementRoutes)
			},
			{
				path: 'profile',
				loadComponent: () =>
					import('./features/user-management/components/user-profile/user-profile.component').then((m) => m.SuperadminUserProfileComponent)
			},
		
		
			{
				path: 'support',
				canMatch: [superadminPermissionCanMatch],
				canActivate: [superadminPermissionCanActivate],
				data: { permission: 'SupportManagement.Read' },
				loadComponent: () =>
					import('./features/support/support-page.component').then((m) => m.SuperadminSupportPageComponent)
			},
			{
				path: 'support/query-detail/:id',
				loadComponent: () =>
					import('./features/support/query-detail/query-detail').then((m) => m.QueryDetail)
			},
			    {
                path: 'notification',
				canMatch: [superadminPermissionCanMatch],
				canActivate: [superadminPermissionCanActivate],
				data: { permission: 'NotificationManagement.Read' },
                loadComponent: () =>
                    import('./features/notification/notification').then((m) => m.NotificationComponent)
            },
		]
	},
	{
		path: 'error/:code',
		loadComponent: () =>
			import('../../../../libs/core/shared/ui/error-reusable/error-reusable').then((m) => m.ErrorReusableComponent)
	},
	{
		path: '**',
		pathMatch: 'full',
		redirectTo: 'error/404'
	}
];
